module.exports = __webpack_public_path__ + "static/media/appstore.56cee221.svg";